import { Dispatch, SetStateAction, useEffect } from 'react'
import { METADATA_INITIAL_FILTER } from '../../constants'

type Params = {
  filterFieldName: string
  metadataCompareFieldName?: string
  metadatas: any[]
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
  setMetadata: Dispatch<SetStateAction<any>>
}

export function useSetMetadataAndResetMetadataInfos({
  metadataCompareFieldName = 'name',
  filterFieldName,
  filter,
  metadatas,
  setFilter,
  setMetadata,
}: Params) {
  const resetMetadatasValuesOnChangeMetadata = () => {
    setFilter({
      ...filter,
      ...METADATA_INITIAL_FILTER,
    })
  }

  useEffect(() => {
    resetMetadatasValuesOnChangeMetadata()
    if (filter[filterFieldName]) {
      const [selectedMetadata] = metadatas.filter((metadata) => metadata[metadataCompareFieldName] == filter[filterFieldName])
      if (selectedMetadata) setMetadata(selectedMetadata)
    } else {
      setMetadata({})
    }
  }, [filter[filterFieldName]])
}
